const debounce = require("lodash.debounce");
import { moment } from '../../utils/moment';
import { dataLayerConfig } from "../../features/dataLayer";
// Shared generic date formatting logic
const formatDates = (event, formatSingle, rangeSeparator, timeSeparator)=>{
    const { Start, End } = event;
    const start = moment(Start).milliseconds(0);
    const midnight = moment(Start).endOf('day');
    const end = moment(End);
    // If the dates span multiple dates
    // return two formated dates, including time when relevant.
    if (midnight.isBetween(start, end)) {
        return `${formatSingle(start)}${rangeSeparator}${formatSingle(end)}`;
    }
    // If we have proper time for start and end
    // return one formated date with both times
    if (hasTime(start) && hasTime(end)) {
        return `${formatSingle(start)}${timeSeparator}${end.format('HH:mm')}`;
    }
    // Else, return whatever Start will yield
    return formatSingle(start);
};
export const formatDatesShort = (event)=>formatDates(event, formatSingleDateShort, ' – ', ' - ');
// Overview cards (VBP-534): never a year; date and time split so the date can render bold.
// Ranges that already started only show when they end ("t/m ...").
export const formatDatesOverview = (event)=>{
    const { Start, End } = event;
    const start = moment(Start).milliseconds(0);
    const midnight = moment(Start).endOf('day');
    const end = moment(End);
    if (midnight.isBetween(start, end)) {
        const now = moment();
        return start.isBefore(now) && end.isSameOrAfter(now) ? {
            date: `t/m ${formatSingleDateOverview(end)}`
        } : {
            date: `${formatSingleDateOverview(start)} – ${formatSingleDateOverview(end)}`
        };
    }
    if (hasTime(start) && hasTime(end)) {
        return {
            date: formatSingleDateOverview(start),
            time: `${start.format('HH:mm')} - ${end.format('HH:mm')}`
        };
    }
    return {
        date: formatSingleDateOverview(start)
    };
};
const formatSingleDateOverview = (date)=>date.format('dd D MMMM');
export const formatDatesDetail = (event)=>{
    const { Start, End } = event;
    const start = moment(Start).milliseconds(0);
    const midnight = moment(Start).endOf('day');
    const end = moment(End);
    const allDaySingle = !hasTime(start) && end.isSame(moment(start).startOf('day').add(1, 'day'));
    if (!allDaySingle && midnight.isBetween(start, end)) {
        const now = moment();
        return start.isBefore(now) && end.isSameOrAfter(now) ? {
            date: `t/m ${formatSingleDateDetail(end)}`
        } : {
            date: `${formatSingleDateDetail(start)} t/m ${formatSingleDateDetail(end)}`
        };
    }
    if (hasTime(start) && hasTime(end)) {
        return {
            date: formatSingleDateDetail(start),
            time: `${start.format('HH:mm')} - ${end.format('HH:mm')} uur`
        };
    }
    return {
        date: formatSingleDateDetail(start)
    };
};
const formatSingleDateDetail = (date)=>date.format('D MMMM');
export const formatDatesLong = (event)=>formatDates(event, formatSingleDateLong, ' t/m ', ' tot ');
const formatSingleDateShort = (date)=>date.format(hasTime(date) ? 'dd D-M-YYYY HH:mm' : 'dd D-M-YYYY');
const formatSingleDateLong = (date)=>date.format(hasTime(date) ? 'dddd DD MMMM, H:mm' : 'dddd DD MMMM');
const hasTime = (date)=>!date.isSame(moment(date).startOf('day'));
export const asPrice = (cents)=>(cents / 100).toLocaleString('nl-NL', {
        style: 'currency',
        currency: 'EUR'
    }).replace(',00', ',-');
export const Monday = 1;
export const startOfToday = moment().startOf('day').toDate();
export const tomorrow = function() {
    let plus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1 + plus);
};
export const nextWeek = function() {
    let plus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return getNextWeekDay(new Date(), Monday, plus);
};
export const nextMonth = function() {
    let plus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    const now = new Date();
    const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1 + plus, 1, 0, 0, 0);
    return nextMonth;
};
export const getNextWeekDay = function(startDate, dayOfWeek) {
    let plus = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    const start = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0);
    const dayOffset = dayOfWeek > start.getDay() ? dayOfWeek - start.getDay() : dayOfWeek - start.getDay() + 7;
    start.setDate(start.getDate() + dayOffset + plus * 7);
    return start;
};
export const pushEventAction = ()=>{
    const pushDataLayer = dataLayerConfig();
    return (action, label)=>pushDataLayer({
            category: 'events',
            action,
            label
        });
};
export const debouncedPush = debounce((push, action, label)=>push(action, label), 1500);
